module.exports = __webpack_public_path__ + "media/packs/images/flags/NU-02d933281a5ed9638120a1a445283bc3.svg";